import { ActivityGroupNode, LllNode } from "./lll-nodes"
import { LllNodeBranch } from "./lll-node-branch"


export class LllNextActivitySearcher {

  constructor() {
  }

  getNextActivity(activityNode: LllNode){
    const boundaryNode = this.findSequenceBoundaryNode(activityNode);

    if(!boundaryNode){
      return null;
    }

    function findAllActivityGroups(node: LllNode) {
      const result: ActivityGroupNode[] = [];

      if(node.isActivityGroup()) {
        result.push(node);
        return result;
      }


      const children = node.getChildren() ?? [];
      for(const child of children) {
        if(child.isActivityGroup()) {
          result.push(child);
          continue;
        }
        const childActivityGroups = findAllActivityGroups(child);
        result.push(...childActivityGroups);
      }

      return result;
    }

    const activityGroupList = findAllActivityGroups(boundaryNode)
      // .filter(activityGroup => activityGroup.mode === 'Practice');

    const activities = activityGroupList.flatMap( e => e.activities ?? []);
    const currentActivityIndex = activities.findIndex( e => e.fqn === activityNode.fqn);

    if(currentActivityIndex + 1 < activities.length){
      return activities[currentActivityIndex + 1];
    }

    return null;

  }

  private findSequenceBoundaryNode(activityNode: LllNode){
    const branch = LllNodeBranch.createTo(activityNode)
    const boundaryNode = branch.bottomUpLoop((node)=>{
      return !!node.sequenceBoundary
    })

    return boundaryNode;
  }

}